<script>
    import { nanoid } from 'nanoid'
	import lookups from "../stores/lookupStore";

    import AddressAutoComplete from './AddressAutoComplete.svelte';
    import DatePicker from './DatePicker.svelte';
    import Select from './Select.svelte';
    import Input from './Input.svelte';
	import EmailInput from "../components/EmailInput.svelte";
	import PhoneInput from "../components/PhoneInput.svelte";
    import FormRow from './FormRow.svelte';
    import FormColumn from './FormColumn.svelte';

    export let required = false;
    export let disabled = false;
    export let idPrefix = nanoid(4);
    export let title;
    export let firstName;
    export let surname;
    export let dateOfBirth;
    export let emailAddress;
    export let phoneNumber;
    export let address = null;

</script>


<section>
	<FormRow>
		<FormColumn cols="2">
			<Select {disabled}
				id="{idPrefix}_salutation"
				label="Salutation"
				optionList={$lookups.SalutationOptions}
				bind:value={title}
			/>
		</FormColumn>
		<FormColumn cols="3">
			<Input {required} {disabled}
				id="{idPrefix}_first-name"
				label="First Name"
				bind:value={firstName}
				maxlength="{25}"
			/>
		</FormColumn>
		<FormColumn cols="4">
			<Input {required} {disabled}
				id="{idPrefix}_surname"
				label="Surname"
				bind:value={surname}
				maxlength="{25}"
			/>
		</FormColumn>
		<FormColumn cols="3">
			<DatePicker {required} {disabled}
				openOnClass="calendar-pop"
				label="Date of birth"
				bind:formattedSelected={dateOfBirth}
				id="{idPrefix}_dateOfBirth"
				start={new Date(1940, 0, 1)}
				end={new Date()}
				placeholder="e.g. 01/05/1990"
				startDecade={true}
			/>
		</FormColumn>
	</FormRow>

	<FormRow>
		<FormColumn cols="6">
			<EmailInput {required} {disabled}
				id="{idPrefix}_email"
				label="Email Address"
				bind:value={emailAddress}
				maxlength="{200}"
			/>
		</FormColumn>
		<FormColumn cols="6">
			<PhoneInput {required} {disabled}
				id="{idPrefix}_phone"
				label="Phone Number"
				bind:value={phoneNumber}
				maxlength="{25}"
			/>
		</FormColumn>
	</FormRow>

    <AddressAutoComplete {idPrefix}
            bind:googlePlaceJson={address.GooglePlaceJson}
            bind:formattedAddress={address.FormattedAddress}
            bind:premise="{address.Premise}"
            bind:subpremise="{address.Subpremise}"
            bind:street="{address.Street}"
            bind:suburb="{address.Suburb}"
            bind:state="{address.State}"
            bind:postcode="{address.Postcode}"
            bind:country="{address.Country}"
            bind:countryCode="{address.CountryCode}"
            bind:lat="{address.Lat}"
            bind:lng="{address.Lng}"
            bind:placeId="{address.PlaceId}"
            bind:url="{address.GoogleMapsUrl}"
            {disabled} {required}>
    </AddressAutoComplete>
</section>